import { Injectable } from '@angular/core';
import { CartActions } from '@cart/data-access';
import { PhoneService } from '@main/phone/data-access';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, take, tap } from 'rxjs/operators';

@Injectable()
export class CartEntryErrorEffect {
  cartEntryError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_ADD_ENTRY_FAIL, CartActions.CART_REMOVE_ENTRY_FAIL, CartActions.CART_UPDATE_ENTRY_FAIL),
        map(({ payload }) => payload),
        tap((res: any) => {
          if (
            res?.error?.details &&
            res.error.details.some((e: any) => e.reason === 'noStock' && e.type === 'InsufficientStockError')
          ) {
            this.phoneService
              .getPhone()
              .pipe(take(1))
              .subscribe((phone) => {
                this.snackbarFacade.setSnack({
                  title: 'Товар не добавлен в корзину',
                  text: `Товар закончился на складе. Позвоните нам по телефону ${phone} и наш менеджер подберёт аналог`,
                  theme: SnackTheme.Yellow,
                });
              });

            return;
          }

          this.snackbarFacade.setSnack({
            title: 'Ошибка',
            text: 'Произошла непредвиденная ошибка. Попробуйте повторить попытку позже или обратитесь в службу поддержки',
            theme: SnackTheme.Yellow,
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private snackbarFacade: SnackbarFacade,
    private phoneService: PhoneService,
  ) {}
}
